import { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { Stack } from 'src/components/layout/stack';
import { Link } from 'src/components/navigation/link';
import { PageSpinner } from 'src/components/spinner-container';
import { Heading } from 'src/components/text/heading';
import { useBidCollectorRoot } from 'src/pages/snam-bid-collector/use-bid-collector';

const LocationsOverviewPage = lazy(() => import('./LocationsOverview'));
const BidsOverviewPage = lazy(() => import('./BidsOverview'));

export const SnamBidCollectorSettingsPage = () => {
  const bidCollectorRoot = useBidCollectorRoot();

  if (!bidCollectorRoot.response) {
    return <PageSpinner />;
  }

  if (!bidCollectorRoot.response.data._links.toggleFeature)
    return <ThrowNotFound />;

  return (
    <Stack gap={2}>
      <Heading mode="title">Bid Collector</Heading>

      <div>
        <Stack flow="column" gap={2.5} inline>
          <Link to="/snam-bid-collector/settings" mode="pill">
            Settings
          </Link>

          <Link to="/snam-bid-collector/bids" mode="pill">
            Bids
          </Link>
        </Stack>
      </div>

      <Switch>
        <Route path="/snam-bid-collector" exact>
          <Redirect to="/snam-bid-collector/settings" />
        </Route>

        <Route path="/snam-bid-collector/settings" exact>
          <LocationsOverviewPage bidCollectorRoot={bidCollectorRoot} />
        </Route>

        <Route path="/snam-bid-collector/bids" exact>
          <BidsOverviewPage bidCollectorRoot={bidCollectorRoot} />
        </Route>

        <Route>
          <ThrowNotFound />
        </Route>
      </Switch>
    </Stack>
  );
};
